import { HobbyAudienceEnum } from '../../types/enums/hobby/hobby-audience.enum'
import { HobbiesFilter } from '../../types/models/hobby/hobby'

export const transformHobbyFiltersToUrl = (filters?: HobbiesFilter): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.automaticallyGenerated !== undefined)
    searchParams.set('automaticallyGenerated', String(filters.automaticallyGenerated))

  if (filters.visibleTo && filters.visibleTo.length > 0)
    searchParams.set('visibleTo', filters.visibleTo.join(','))

  return searchParams.toString()
}

export const transformUrlToHobbyFilters = (searchParams: URLSearchParams): HobbiesFilter => {
  const filters: HobbiesFilter = {}

  const automaticallyGenerated = searchParams.get('automaticallyGenerated')
  if (automaticallyGenerated === 'true' || automaticallyGenerated === 'false')
    filters.automaticallyGenerated = automaticallyGenerated === 'true'

  const visibleTo = searchParams.get('visibleTo')
  if (visibleTo)
    filters.visibleTo = visibleTo
      .split(',')
      .filter((audience): audience is HobbyAudienceEnum => audience in HobbyAudienceEnum)

  return filters
}
